/// <reference path="env-config.d.ts" />

export const envConfig: EnvConfig = {
    environment: "LIVE-US",
    debuggerUrl: "https://smartsignals-ceres.smart-digital-solutions.io/dist/smasi2ProfileDebugger/SmartSignalsProfileDebugger.html",
    azureClientId: "6c7d7092-a1be-431e-a922-f4028b90422a",
};
